<template>
  <!--<header id="header" v-header-sticky class="header">-->
  <header id="header" class="header document-scrolled" :class="searchHide?'searchHide':''">
    <div class="header-container normal-header-container">
      <el-row :gutter="10">
        <el-col :span="5">
          <div class="logo"><a href="/"><img src="../assets/images/logo.png" height="32px" width="125px"/></a></div>
        </el-col>
        <el-col :span="13" class="nav">
          <el-row>
            <el-col :span="4" class="gray-txt" style="margin-left: 50px">
              <a href="/MerchantList">商家</a>
            </el-col>
            <!-- <el-col :span="4" class="gray-txt" style="">
              <a href="javascript:void(0);" @click="getGoods()">丝芙兰</a>
            </el-col> -->
            <el-col :span="5" class="gray-txt">
              <a href="/TaskMarket">任务市场</a>
            </el-col>
            <el-col :span="4" class="gray-txt">
              <a href="/explore">社区</a>
            </el-col>
            <!-- <el-col :span="4" class="gray-txt">
              <a  href="https://bbs.joyorders.com">论坛</a>
            </el-col> -->
            <el-col :span="5" class="gray-txt">
              <a href="/HelpCenter">帮助中心</a>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="5" class="quick-nav">

          <div class="clearfix">
            <div class="float-right gray-txt">
              <a href="/cart" class="icon-shopping-cart icon" style="margin-right: 25px;">
                <span v-if="cartCount > 0">{{cartCount}}</span>
              </a>
            </div>
            <div style="margin-right: 25px;" class="float-right gray-txt">
              <a :href="messageUrl" v-if="!userInfo.username || totalCount == 0" class="icon-bell icon">
              </a>
              <el-dropdown v-if="userInfo.username && totalCount > 0" class="yuedan-dropdown header-dedropdown"
                           placement="bottom">
                <a :href="messageUrl" class="icon-bell icon">
                  <span>{{totalCount}}</span>
                </a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div style="line-height: 26px;padding: 6px 0;" class="header-message-list" v-for="m in messages">
                      <span v-html="m.content"></span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item divided class="text-right header-message-list-divided">
                    <a :href="messageUrl">查看全部提醒</a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <div style="margin-right: 25px;" class="float-right gray-txt">

              <a v-if="!userInfo.username" href="/login">登录</a>
              <el-dropdown v-if="userInfo.username" :hide-on-click="false" class="yuedan-dropdown header-dedropdown"
                           placement="bottom">
                <span class="pointer">
                  {{userInfo.username}}
                </span>
                <el-dropdown-menu class="header-dedropdown-menu" slot="dropdown">
                  <el-dropdown-item v-if="userInfo.has_single == 1 || userInfo.has_shipping_manager == 1">
                    <div class="toggole" @click="toggole()">{{(isSingle|| isShippingManager)?'切换到客户账户':'切换到买手账户'}}</div>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-for="(menu,index) in isSingle?SINGLESIDEMENU:(isShippingManager?SHIPPINGMANAGERSIDEMENU:USERMENU)"
                    :key="index">
                    <div
                      style="margin: 0 10px;"
                      :class="{
                        'has-border': menu.border === true,
                        'logout': menu.logout === true
                      }">
                      <a class="user-center-link" :href="menu.url">{{menu.label}}</a>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div style="margin: 0 10px;cursor: pointer;" class="logout">
                      <a class="user-center-link" @click="logout()">退出</a>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div style="margin-right: 25px;" class="float-right small-search" v-if="searchHide" @click="showSearch()">
              <span>搜索</span>
              <i class="el-icon-search"></i>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="!searchHide">
        <el-col :span="12" class="nav" :offset="6">
          <search-ipt v-if="!isShequ" class="search-container" placeholder="搜索商家" :object="filters" object-key="shopName"
                      v-on:search="showsearchLIst"></search-ipt>
          <input v-else class="content_search_input" v-model="searchWord" type="text" placeholder="搜索文章" @input="triggerArticleSearch"/>
        </el-col>
      </el-row>
      <!-- <div class="overlay" @click="hideSearch()"></div> -->
    </div>
    <MobileHeader :userInfo="userInfo" :messageUrl="messageUrl" :totalCount="totalCount"></MobileHeader>
  </header>
</template>

<script>
  import SearchIpt from './SearchIpt'
  import api from '../services/api.js'
  import {USERMENU, SINGLESIDEMENU, SHIPPINGMANAGERSIDEMENU} from '../services/constant.js'
  import MobileHeader from './MobileHeader'

  let $ = require('jQuery')
  let _ = require('lodash')

  export default {
    name: 'Header',
    created() {
      //this.getUserInfo()
      setTimeout(() => {
        this.headerStyle(this.$route.path)
      })
    },
    computed: {
      globalDialog() {
        return this.$store.state.globalDialog
      },
      globalUserInfo() {
        return this.$store.state.userInfo
      },
    },
    components: {
      searchIpt: SearchIpt,
      MobileHeader: MobileHeader
    },
    async mounted() {
      // 事件监听滚动条
      if(this.$route.fullPath.indexOf('explore?tag')>-1)
          this.searchWord=this.$route.query.tag;
      this.isShequ = this.$route.path=='/explore' || this.$route.path=='/publish' || this.$route.path=='/mypost'
      window.addEventListener('scroll', this.watchScroll)
      await this.getUserInfo();
      if (this.$localStorage.get('single_type') == 2) {
        this.SINGLESIDEMENU = SINGLESIDEMENU.filter(i => !i.noexternal)
      } else {
        this.SINGLESIDEMENU = SINGLESIDEMENU
      }
    },
    data() {
      return {
        isShequ:false,
        isSingle: null,
        isShippingManager: null,
        filters: {
          shopName: null
        },
        SINGLESIDEMENU: [],
        SHIPPINGMANAGERSIDEMENU: SHIPPINGMANAGERSIDEMENU,
        USERMENU: USERMENU,
        userInfo: {},
        totalCount: null,
        cartCount: 0,
        messageUrl: null,
        messages: null,
        searchHide: false,
        searchWord:''
      }
    },
    beforeRouteEnter(to, from, next) {
      next()
      next(vm => {
        vm.userInfo = vm.globalUserInfo || {}
      })
    },
    methods: {
      triggerArticleSearch(){
        this.$store.commit('setArticleKeyword', this.searchWord); 
      },
      async logout() {
        let res = await api.post(this, {
          path: 'passport.php',
          api: 'logout'
        })
        this.$localStorage.remove('token')
        this.$localStorage.remove('openid')
        this.$localStorage.remove('username')
        this.$localStorage.remove('taskInfo')
        this.$localStorage.remove('account_id')
        this.$localStorage.remove('is_community_administrator')
        this.$localStorage.remove('goBackOrderUrl')
        this.$localStorage.remove('single_type')
        sessionStorage.removeItem('isSingle')
        sessionStorage.removeItem('has_shipping_manager')
        location.reload()
      },
      watchScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        //  当滚动超过 100 时，实现吸顶效果
        if (scrollTop > 100) {
          this.searchHide = true
        } else {
          this.searchHide = false
        }
      },
      scrolltobueyer() {
        if (this.pathname != 'home') {
          this.$router.push('/')
        }
        document.querySelector('.buyer').scrollIntoView(false)
      },
      async getUserInfo() {
        if (window.localStorage.getItem('token')) {
          try {
            let {body} = await api.getUserInfo(this)
            let result = body.result
            this.userInfo = result
            if (!sessionStorage.getItem('isSingle')) {
              if (this.userInfo.has_single == '1') {
                this.isSingle = 1
                /*if (this.$route.fullPath.indexOf('buyer') == -1) {
                  this.isSingle = 0;
                }*/
              } else {
                this.isSingle = 0
              }
              sessionStorage.setItem('isSingle', this.isSingle)
            } else {
              this.isSingle = Number(sessionStorage.getItem('isSingle'))
            }
            if (!sessionStorage.getItem('has_shipping_manager')) {
              if (this.userInfo.has_shipping_manager == '1') {
                this.isShippingManager = 1
                /*if (this.$route.fullPath.indexOf('buyer') == -1) {
                  this.isShippingManager = 0;
                }*/
              } else {
                this.isShippingManager = 0
              }
              sessionStorage.setItem('has_shipping_manager', this.userInfo.has_shipping_manager)
            } else
              this.isShippingManager = Number(sessionStorage.getItem('has_shipping_manager'));
            this.$store.commit('updateUserInfo', result)
            this.$emit('updateMenu')
            this.$localStorage.set('account_id', result.account_id)
            this.$localStorage.set('is_community_administrator', result.is_community_administrator)
            this.$localStorage.set('role', result.role)
            this.$localStorage.set('single_type', result.single_type)
            this.$store.commit('updateSingleType', result.single_type)
            this.getCountUnread(this.$route.path)
            this.getCartList()
            // this.getImToken(result.account_id)
            // 初始化聊天工具
          } catch (e) {
            console.log('eeeeee', e)
          }
        }
      },
      toggole() {
        if (this.isSingle == 1) {
          this.$router.push({path: '/customer/profile'})
          this.isSingle = 0
        } else if (this.isShippingManager == 1) {
          this.$router.push({path: '/customer/profile'})
          this.isShippingManager = 0
        } else {
          this.isSingle = Number(this.userInfo.has_single)
          this.isShippingManager = Number(this.userInfo.has_shipping_manager)
          //if(this.isSingle)
          this.$router.push({path: '/buyer/dashboard'})
          //else
          //this.$router.push({path:'/buyer/task/list?page=1'})
        }
        sessionStorage.setItem('isSingle', this.isSingle)
        sessionStorage.setItem('has_shipping_manager', this.isShippingManager)

      },
      async createImToken(account_id, type = 'user') {
        let {body} = await api.post(this, {
          path: 'passport.php',
          data: {type, account_id},
          api: 'create_im_accid'
        })
        // this.getImToken(account_id, this.userInfo.has_single == 1 ? 'single': 'buyer')
      },
      async getImToken(account_id, type = 'user') {
        let {body} = await api.post(this, {
          path: 'passport.php',
          data: {type, account_id},
          api: 'get_im_token'
        })
        let result = body.result || {}
        if (!result.token) {
          this.createImToken(account_id)
          return
        }
        this.$store.commit('setNim', {
          token: result.token,
          accid: result.accid,
          username: this.userInfo.username
        })
      },
      // async getUnreadForBuyer () {
      //   let { body } = await api.getUnreadForBuyer(this)
      //   let result = body.result || []
      //   this.messages = result
      // },
      // async getUnreadForSingle () {
      //   let { body } = await api.getUnreadForSingle(this)
      //   let result = body.result || []
      //   this.messages = result
      // },
      // async countUnreadForSingle () {
      //   let { body } = await api.countUnreadForSingle(this)
      //   let result = body.result
      //   this.totalCount = result
      // },
      // async countUnreadForBuyer () {
      //   let { body } = await api.countUnreadForBuyer(this)
      //   let result = body.result
      //   this.totalCount = result
      // },
      async getUnread() {
        let {body} = await api.getUnread(this)
        let result = body.result || []
        this.messages = result
      },
      async countUnread() {
        let {body} = await api.countUnread(this)
        let result = body.result
        this.totalCount = result
      },
      async getCartList() {
        if (!window.localStorage.getItem('token')) return
        let res = await api.getCartList(this)
        let list = []
        if (res.body.result) {
          list = res.body.result
        }
        this.cartCount = 0
        _.each(list, item => {
          if (item && item.status == '0') {
            this.cartCount += Number(item.number)
          }
        })
      },
      headerStyle(path) {
        if (path === '/' || path === '/MerchantList' || path === '/TaskMarket' || path === '/items' || path === '/item' || path.indexOf('cart') > -1 || path === '/Complete' || path === '/HelpCenter' || path === '/customer/address/list' || path === '/customer/profile' || path === '/buyer/income' || path === '/buyer/dashboard' || path === '/buyer/withdraw' || path === '/Merchant' || path.indexOf('order/list') > -1) {
          $('#app').addClass('use-mobile-style')
        } else {
          $('#app').removeClass('use-mobile-style')
        }
      },
      getCountUnread(path) {
        if (!window.localStorage.getItem('token')) {
          return
        }
        if (path.indexOf('items') == -1 && path.indexOf('products') == -1) {
          localStorage.removeItem('SearchKeyword')
        }
        // if (path.indexOf('single') > -1) {
        //   this.messageUrl = '#/messages/single'
        //   this.countUnreadForSingle()
        //   this.getUnreadForSingle()
        // } else {
        //   this.messageUrl = '#/messages/buyer'
        //   this.countUnreadForBuyer()
        //   this.getUnreadForBuyer()
        // }
        console.log('path', path)
        this.countUnread()
        this.getUnread()
        this.messageUrl = '/messages'
      },
      showSearch() {
        // $('#header').addClass('show-search')
        // $('.overlay').height($('html').height())
        this.searchHide = false
      },
      hideSearch() {
        $('#header').removeClass('show-search')
        $('.overlay').height(0)
      },
      getGoods() {
        this.$router.push({name: 'Goods', params: {id: 'SephoraUS'}})
      },
      showsearchLIst(data) {
        console.log(data)
        if (data) {
          window.removeEventListener('scroll', this.watchScroll)
        } else {
          window.addEventListener('scroll', this.watchScroll)
        }
      }
    },
    watch: {
      $route(val, oldVal) {
        this.getCountUnread(val.path)
        this.headerStyle(val.path)
        // this.getCartList()
      },
      'globalDialog.loginVisible'(val) {
        console.log('loginchange')
        if (!val && this.$localStorage.get('token')) {
          this.getUserInfo()
        }
      },
      'globalDialog.cartChangeVisible'(val, oldVal) {
        this.getCartList()
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .content_search_input{
    display: block;
    width:100%;
    height: 38px;
    border: 1px solid #d7d7d7;
    line-height: 18px;
    padding: 10px;
    background: #f3f3f9;
    padding-right: 45px;
    margin:auto;
  }
  .header {
    position: fixed;
    top: 0;
    z-index: 999;
    background-color: #fff;
    width: 100%;
    margin: 0 auto;
    margin-bottom: 50px;
    padding: 40px 0 0px;
    border-bottom: 1px solid #d7d7d7;
    height: 145px;

    &.searchHide {
      height: 94px !important;
    }

    .search-container {
      // display: none;
    }

    .small-search {
      display: none;
      cursor: pointer;
    }

    &.document-scrolled {
      .search-container {
        // display: none;
      }

      .small-search {
        display: block;
      }
    }

    &.show-search {
      .search-container {
        display: block;
      }

      .small-search {
        // display: none;
      }
    }

    .logo {
      img {
        margin-left: 60px;
      }

      a {
        font-family: Impact;
        color: rgba(0, 0, 0, 1);
        line-height: 31px;
        display: block;
      }
    }

    .nav {
      margin-top: 6px;

    }

    .quick-nav {
      margin-top: 0px;
      line-height: 24px;

      .icon {
        font-size: 18px;

        &.icon-shopping-cart {
          font-size: 19px;
        }
      }
    }
  }

  .small-search {
    color: #B7B7B7;

    span {
      font-size: 12px;
      padding-right: 5px;
    }

    .el-icon-search {
      color: #333;
      font-size: 20px;
      position: relative;
      top: 2px;
    }
  }

  .user-center-link {
    color: #666666;
  }

  .popper__arrow {
    display: none;
  }

  .has-border {
    border-bottom: 1px solid #D7D7D7;
    padding-bottom: 8px;
    margin-bottom: 12px !important;
  }

  .logout {
    margin-top: 10px;

    a {
      &, a:hover {
        color: #3C6FEE;
        border-color: #3C6FEE;
      }
    }
  }

  .toggole {
    color: #3C6FEE;
    margin: 0 10px;
    border-bottom: 1px solid #D7D7D7;
    margin-bottom: 12px !important;
    cursor: pointer;
  }

  .overlay {
    width: 100%;
    background-color: #000;
    top: 145px;
    left: 0;
    position: absolute;
    z-index: 99;
    opacity: 0.5;
    cursor: pointer;
  }
</style>
<style lang="scss">
  .header-dedropdown-menu {
    max-height: 500px !important;
    width: 180px !important;
    overflow: hidden;

    .el-dropdown-menu__item {
      line-height: 32px;
    }
  }

  .header-message-list-divided {
    border-color: #D7D7D7;
    padding-top: 0;
    padding-bottom: 0;

    a {
      color: #666;
    }
  }

  .header-message-list {
    width: 360px;
    border-bottom: 1px solid #D7D7D7;

    &:last-child {
      border: none;
    }

    a {
      &, &:hover {
        border: none !important;
        text-decoration: none !important;
      }
    }

    &:hover {
      background-color: #F9F9FA;
    }
  }

  .icon-bell {
    position: relative;

    span {
      display: inline-block;
      min-width: 15px;
      height: 15px;
      background: #F12C20;
      color: #fff;
      text-align: center;
      border-radius: 100%;
      font-size: 12px;
      line-height: 15px;
      top: -6px;
      position: absolute;
      right: -5px;
    }
  }

  .icon-shopping-cart {
    position: relative;

    span {
      display: inline-block;
      min-width: 15px;
      height: 15px;
      background: #F12C20;
      color: #fff;
      text-align: center;
      border-radius: 100%;
      font-size: 12px;
      line-height: 15px;
      top: -6px;
      position: absolute;
      right: -5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue